import { StyledModal } from '@app/components/modal/Modal';
import { UserForm } from './UserForm';
import type { ModalProps } from 'antd';
import type { RoleOption, User } from '@app/services/api.types';
import useUserActions from '@app/hooks/users/useUserActions';

export type UserAddModalProps = ModalProps & {
    title?: string;
    data?: User;
    roles?: RoleOption[];
};

export const UserAddModal = ({
    title = 'Add New User',
    roles = [],
    data,
    ...props
}: UserAddModalProps) => {
    const { addUser } = useUserActions();

    return (
        <StyledModal title={title} maskClosable={false} {...props} footer={null}>
            <UserForm
                data={data}
                roles={roles}
                isEdit={false}
                onCancel={props.onCancel}
                confirmLoading={addUser.isPending}
                onSubmit={(values, reset) => {
                    addUser.mutate(values, {
                        onSuccess: () => {
                            reset();

                            if (props?.onOk) {
                                props.onOk(
                                    undefined as unknown as React.MouseEvent<HTMLButtonElement>
                                );
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
